<template>
  <div class="list-cards payout-options">
    <div v-for="card in getOptions()" :key="card.title">
      <payout-limits-card
        :title="card.title"
        :icon="card.icon"
        :list="card.list"
        :grouped-limits="groupedLimits"
        :download="loading"/>
    </div>
  </div>
</template>

<script>
import PayoutLimitsCard from './PayoutLimitsCard'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'PayoutOptions',
  components: {
    PayoutLimitsCard
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({
      payoutLimits: 'superadministrator/payoutLimits'
    }),
    groupedLimits() {
      let groups = []
      for (const limit of this.payoutLimits) {
        let newGroup
        const groupName = limit.name.slice(0, -4)
        const limitDirection = limit.name.slice(-3)
        const group = groups.find(item => item.name === groupName)
        if (group) {
          newGroup = {
            ...group,
            [limitDirection + 'Id']: limit.id,
            [limitDirection + 'Value']: limit.value
          }
          groups = groups.map(item => item.name === groupName ? newGroup : item)
        } else {
          const groupTitle = limit.meta.ru.description.split(',')[0]
          const getGroupCurrency = () => {
            const usdExceptionNames = ['usdt', 'paytm']
            for (const name of usdExceptionNames) {
              if (limit.name.includes(name)) return 'usd'
            }
            return groupName.slice(-3)
          }
          newGroup = {
            name: groupName,
            title: groupTitle,
            currency: getGroupCurrency(),
            [limitDirection + 'Id']: limit.id,
            [limitDirection + 'Value']: limit.value
          }
          groups.push(newGroup)
        }
      }
      return groups
    },
    rubList() {
      return this.groupedLimits.filter(item => item.currency === 'rub')
    },
    usdList() {
      const usdList = this.groupedLimits.filter(item => item.currency === 'usd')
      for (let item in usdList) {
        if (usdList[item].name.slice(-7)
          .split('_')[0] === 'all') {
          usdList.push(usdList.splice(Number(item), 1)[0])
        }
      }
      return usdList
    }
  },
  methods: {
    ...mapMutations({
      setPayoutLimits: 'superadministrator/setPayoutLimits'
    }),
    ...mapActions({
      downloadPayoutLimits: 'superadministrator/downloadPayoutLimits'
    }),
    getOptions() {
      return [
        {
          title: 'Выводы в рублях',
          list: this.rubList,
          icon: 'Russian-Federation'
        },
        {
          title: 'Выводы в USD',
          list: this.usdList,
          icon: 'USD'
        }
      ]
    },
    async getData() {
      this.loading = true
      try {
        await this.downloadPayoutLimits()
      } finally {
        this.loading = false
      }
    }
  },
  async beforeMount() {
    this.getData()
  },
  beforeUnmount() {
    this.setPayoutLimits([])
  }
}
</script>

<style scoped>

</style>
